import { PageContainer } from '@ant-design/pro-components';
import { Button, Card, Result } from 'antd';
import { Link } from 'react-router-dom';
import { useOrganizationPath } from '@/common/hooks/use-organization-path';

export default () => {
  const { resolveOrganizationPath } = useOrganizationPath();
  return (
    <PageContainer pageHeaderRender={false}>
      <Card variant="borderless">
        <Result
          status="404"
          title="404"
          subTitle="Sorry, the page you visited does not exist."
          extra={
            <Link to={resolveOrganizationPath('/')}>
              <Button type="primary">Back Home</Button>
            </Link>
          }
        />
      </Card>
    </PageContainer>
  );
};
